<script setup lang="ts">
import { computed, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import DemoVideo from '@/components/DemoVideo.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import SiteHeader from '@/components/SiteHeader.vue'
import WorkCard from '@/components/WorkCard.vue'
import { NOVA_AI_URL } from '@/config/external-links'
import { demoVideos } from '@/data/videoDemo'

const route = useRoute()
const video = computed(() => demoVideos.find((item) => item.id === String(route.params.id)))
const related = computed(() => demoVideos.filter((item) => item.id !== video.value?.id).slice(0, 3))

watchEffect(() => {
  if (video.value) document.title = `${video.value.title}｜Nova·云枢`
})
</script>

<template>
  <div class="detail-page-shell">
    <SiteHeader />
    <main class="dark-detail-page">
      <div class="shell detail-shell">
        <RouterLink to="/works" class="back-link light">← 返回视频作品</RouterLink>

        <template v-if="video">
          <section class="video-detail-grid">
            <div class="detail-player"><DemoVideo :video="video" mode="hero" :loop="false" /></div>
            <div class="detail-copy">
              <h1>{{ video.title }}</h1>
              <p>{{ video.context }}</p>
              <dl class="detail-facts">
                <div><dt>视频类型</dt><dd>{{ video.type }}</dd></div>
                <div><dt>时长</dt><dd>{{ video.duration }}</dd></div>
                <div><dt>画面比例</dt><dd>{{ video.ratio }}</dd></div>
                <div><dt>当前用途</dt><dd>播放体验验收</dd></div>
              </dl>
              <p class="detail-notice">当前为已获许可的演示素材，不作为 Nova 正式案例。正式视频与封面提供后可直接替换。</p>
              <div class="detail-actions">
                <a class="primary-action" :href="NOVA_AI_URL" target="_blank" rel="noopener">进入 AI 创作平台</a>
                <a :href="video.sourcePage" target="_blank" rel="noopener">查看素材来源</a>
                <a :href="video.licensePage" target="_blank" rel="noopener">查看授权说明</a>
              </div>
            </div>
          </section>
          <section class="recommend-section">
            <h2>继续浏览</h2>
            <div class="work-grid"><WorkCard v-for="item in related" :key="item.id" :video="item" /></div>
          </section>
        </template>

        <section v-else class="dark-empty-state" role="status">
          <h1>未找到这个视频</h1>
          <p>该链接可能已更新，请返回视频作品页重新选择。</p>
          <RouterLink class="primary-action" to="/works">返回视频作品</RouterLink>
        </section>
      </div>
    </main>
    <SiteFooter />
  </div>
</template>
